import { getErrorss } from "../../../functions/errors/GetErrors"
import { getQueryUnits } from "../../../functions/shared/api/queries/getQueryUnits"
import { ACCESS_KEY, urlAPI } from "../../../urls"
import { dataFetchingFinish, dataFetchingStart } from "../../slices/modalSlice"
import { type AppDispatch, type RootState } from "../../store"
import {  singleUnitFetchingSuccess } from "../unitsActions"
import { fetchUser } from "../userActions"
import { fetchUnits } from "./fetchUnits"

export const manageVerifiedRejectAgentUnit = (unitBody:Record<string , any>) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    
    
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
    try {
        dispatch(dataFetchingStart())
        const bodyObject = {
            method: 'PUT',
            collection: 'units',
            id: unitBody.unitID,
            body: unitBody.body ,
            query: getQueryUnits()
        }
        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(bodyObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const responseJSON = await response.json() as unknown as any


        if (responseJSON.success) {
            if (responseJSON.response.error != null) {
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
            } else {     
                const { isSuccessful } = dispatch(singleUnitFetchingSuccess(responseJSON))
                if (!isSuccessful) {
                    await dispatch(fetchUnits(true))
                    await dispatch(fetchUser(true))
                }
                dispatch(dataFetchingFinish())
                return {
                    textNavigate: ``,
                    isSuccessful: true,
                    textNotification: unitBody.textNotification
                }
            }
        } else {
            dispatch(dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
        }
    } catch (error) {
        dispatch(dataFetchingFinish())

        return { textNavigate: '', isSuccessful: false, textNotification: getErrorss("error") }
    }

}